<template>
  <div class="empty-state">
    <svg v-if="!$slots.icon" class="empty-state__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
         fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="10"/>
      <line x1="12" y1="8" x2="12" y2="12"/>
      <line x1="12" y1="16" x2="12.01" y2="16"/>
    </svg>
    <slot name="icon"/>
    <p class="empty-state__title">{{ title }}</p>
    <p v-if="message" class="empty-state__message">{{ message }}</p>
    <button v-if="actionLabel" class="btn" @click="$emit('action')">{{ actionLabel }}</button>
  </div>
</template>

<script>
export default {
  name: 'EmptyState',
  props: {
    title: { type: String, required: true },
    message: { type: String, default: '' },
    actionLabel: { type: String, default: '' }
  },
  emits: ['action']
}
</script>
